import {
	KeyboardAvoidingView,
	Modal,
	Text,
	View,
	type GestureResponderEvent,
	type NativeSyntheticEvent,
	type NativeTouchEvent,
	type TextInputKeyPressEvent,
} from 'react-native';
import { HelperText, TextInput } from 'react-native-paper';
import Translations from 'src/core/utils/Translations';
import { PrimaryButton, SecondaryButton } from 'src/presentation/components/molecules/Button';
import dialogStyles from 'src/presentation/dialogs/styles/DialogStyles';
import SelectField, { type PickerItem } from 'src/presentation/components/molecules/SelectField';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';

interface Props {
	barcodeText: string;
	buttonText?: string;
	buttonTextClaim?: string;
	errorBarcode?: string | null;
	isLoading?: boolean;
	items: PickerItem[];
	onKeyPress?: (e: TextInputKeyPressEvent) => void;
	onPress: (event: GestureResponderEvent) => void;
	onPressClaim?: (event: GestureResponderEvent) => void;
	onPressIn?: (e: NativeSyntheticEvent<NativeTouchEvent>) => void;
	selectedValue?: string;
	setBarcodeText: (text: string) => void;
	setSelectedValue: (value: string, index: number) => void;
	title: string;
	visible?: boolean;
}

const AddBathCardDialog = ({
	barcodeText,
	buttonText = Translations.cancel,
	buttonTextClaim = Translations.add,
	errorBarcode,
	isLoading = false,
	items,
	onKeyPress,
	onPress,
	onPressClaim,
	onPressIn,
	selectedValue,
	setBarcodeText,
	setSelectedValue,
	title,
	visible,
}: Props) => {
	return (
		<Modal animationType="fade" style={dialogStyles.modalView} transparent={true} visible={visible}>
			<KeyboardAvoidingView behavior="padding" style={dialogStyles.centeredView}>
				<View style={dialogStyles.modalCard}>
					<Text style={dialogStyles.modalTitle}>{title}</Text>

					<SelectField
						items={items}
						style={{ marginBottom: Dimens.padding10 }}
						value={selectedValue}
						onValueChange={setSelectedValue}
					/>

					<TextInput
						activeUnderlineColor={Colors.green}
						label={Translations.dialogBarcode}
						selectionColor={Colors.gray600}
						style={{ backgroundColor: Colors.gray200 }}
						value={barcodeText}
						onChangeText={setBarcodeText}
						onKeyPress={onKeyPress}
						onPressIn={onPressIn}
					/>

					<HelperText style={{ marginBottom: Dimens.padding20 }} type="error" visible={!!errorBarcode}>
						{errorBarcode}
					</HelperText>

					<View style={{ flexDirection: 'row' }}>
						<SecondaryButton
							extraStyle={{ paddingHorizontal: Dimens.padding10, flex: Dimens.flex1 }}
							label={buttonText}
							onPress={onPress}
						/>
						<PrimaryButton
							extraStyle={{ paddingHorizontal: Dimens.padding10, flex: Dimens.flex1 }}
							label={buttonTextClaim}
							loading={isLoading}
							onPress={onPressClaim}
						/>
					</View>
				</View>
			</KeyboardAvoidingView>
		</Modal>
	);
};

export default AddBathCardDialog;
